import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const GAME_IMAGE_PLACEHOLDER = '/games/game-placeholder.svg';

export function resolveAssetUrl(value, fallback = GAME_IMAGE_PLACEHOLDER) {
  if (!value || typeof value !== 'string') return fallback;
  const url = value.trim();
  if (!url) return fallback;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith('//')) return `${window.location.protocol}${url}`;
  if (url.startsWith('/')) return url;
  return `/${url.replace(/^\/+/, '')}`;
}

export function optimizedUploadUrl(value, width = 720, quality = 72) {
  if (!value || typeof value !== 'string') return value;
  const raw = value.trim();
  if (!raw || /^(data:|blob:)/i.test(raw)) return raw;
  const widthValue = Math.max(96, Math.min(2000, Number(width) || 720));
  const qualityValue = Math.max(45, Math.min(85, Number(quality) || 72));
  const appendParams = (url) => {
    const joiner = url.includes('?') ? '&' : '?';
    return `${url}${joiner}w=${widthValue}&q=${qualityValue}`;
  };
  if (raw.startsWith('/api/uploads/')) return appendParams(raw);
  if (raw.startsWith('/uploads/')) return appendParams(raw.replace(/^\/uploads\//, '/api/uploads/'));
  try {
    const url = new URL(raw);
    if (url.pathname.startsWith('/api/uploads/')) {
      url.searchParams.set('w', String(widthValue));
      url.searchParams.set('q', String(qualityValue));
      return url.toString();
    }
    if (url.pathname.startsWith('/uploads/')) {
      url.pathname = url.pathname.replace(/^\/uploads\//, '/api/uploads/');
      url.searchParams.set('w', String(widthValue));
      url.searchParams.set('q', String(qualityValue));
      return url.toString();
    }
  } catch {
    return raw;
  }
  return raw;
}

export function bannerSlideDurationMs(banner, fallbackMs = 7000) {
  const raw = banner?.slide_duration_ms
    ?? banner?.display_duration_ms
    ?? banner?.duration_ms
    ?? banner?.slide_seconds;
  let ms = Number(raw);
  if (!Number.isFinite(ms) || ms <= 0) ms = Number(fallbackMs) || 7000;
  if (ms > 0 && ms < 1000) ms *= 1000;
  return Math.max(2000, Math.min(30000, Math.round(ms)));
}
